export const VALID_UNITS = ["MG", "MCG", "G", "ML", "IU", "%"];

export const normalizeMedicineSalt = (input = "") => {
  if (!input) return "";

  let value = input.toUpperCase().trim();

  value = value.replace(/\s+/g, " ");
  value = value.replace(/[/,]/g, " + ");
  value = value.replace(/([A-Z])([0-9])/g, "$1 $2");
  value = value.replace(/(\d)(MG|MCG|G|ML|IU|%)/g, "$1 $2");

  // fix reversed format: 322 MG PARA => PARA 322 MG
  value = value.replace(
    /(\d+(\.\d+)?)\s(MG|MCG|G|ML|IU|%)\s([A-Z\s()-]+)/g,
    (_, num, __, unit, name) => `${name.trim()} ${num} ${unit}`,
  );

  value = value.replace(/\s*\+\s*/g, " + ");
  value = value.replace(/\++/g, "+");
  value = value.replace(/\s+/g, " ").trim();

  return value;
};

export const validateMedicineSalt = (input = "") => {
  if (!input?.trim()) {
    return { valid: false, message: "Medicine salt is required" };
  }

  const value = normalizeMedicineSalt(input);

  if (!/^[A-Z0-9+/,.()%\s-]+$/.test(value)) {
    return { valid: false, message: "Contains invalid characters" };
  }

  if (/(\+\+)|(\/\/)|(,,)/.test(value)) {
    return { valid: false, message: "Invalid separator usage" };
  }

  if (/^[+,/]|[+,/]$/.test(value)) {
    return { valid: false, message: "Invalid separator placement" };
  }

  // if (!/(\d+(\.\d+)?)\s?(MG|MCG|G|ML|IU|%)/g.test(value)) {
  //   return { valid: false, message: "Strength with valid unit is required (e.g. PARACETAMOL 500 MG)" };
  // }

  const ingredients = value.split("+");
  for (const ingredient of ingredients) {
    const trimmed = ingredient.trim();
    if (!/^[A-Z\s()-]+ \d+(\.\d+)?\s(MG|MCG|G|ML|IU|%)$/.test(trimmed)) {
      return {
        valid: false,
        message: `Invalid format near "${trimmed}" — expected: NAME DOSE UNIT (e.g. PARACETAMOL 500 MG)`,
      };
    }
  }

  return {
    valid: true,
    message: "Valid medicine salt",
    normalizedValue: value,
  };
};
